import React from 'react';
import ComingSoonPage from './componenets/ComingSoonPage';

export const JanazahProcess = () => {
  return <ComingSoonPage title="Janazah process" description="A clear guide to the funeral and burial process in accordance with Islamic tradition." image="/images/HomeSlider12.jpg" />;
}
